import React, { Component } from 'react';
import {
  Modal,
  Card,
  Row,
  Col,
  Typography,
  Space,
  Divider,
  InputNumber,
  message,
  Spin,
  Button,
} from 'antd';
import {
  SaveOutlined,
  CalculatorOutlined,
  DollarOutlined,
  CreditCardOutlined,
  FileTextOutlined,
  BankOutlined
} from '@ant-design/icons';
import axios from 'axios';
import ButtonItem from '../../../Components/ButtonItem';
import ModalConteoEfectivo from './ModalConteoEfectivo/ModalConteoEfectivo';
import { dineroDisabledMask, TextAreaItem } from '../../../Components/Items';
import ModalPdfCorteCaja from './ModalPdfCorteCaja/ModalPdfCorteCaja';

const { Title, Text } = Typography;

class ModalCorteCaja extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Valores contados
      efectivo: 0,
      cheque: 0,
      vales: 0,
      tarjeta: 0,
      transferencia: 0,

      // Valores calculados del sistema
      efectivoCalculado: 0,
      chequeCalculado: 0,
      valesCalculado: 0,
      tarjetaCalculado: 0,
      transferenciaCalculada: 0,

      // Información adicional
      totalTransferencias: 0,
      totalAnticipos: 0,

      loading: false,
      loadingData: false,

      // Estado para el modal de conteo de efectivo
      modalConteoEfectivoVisible: false,
      pdfVisible: false,
      observaciones: '',
    };
  }

  componentDidMount() {
    if (this.props.visible) {
      this.consultarDatosCaja();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.consultarDatosCaja();
    }
  }

  consultarDatosCaja = async () => {
    try {
      this.setState({ loadingData: true });

      const res = await axios.post(
        "sesionesPV/obtenerTotales",
        { sesionId: this.props.sesionId },
        { headers: this.props.headersToken }
      );

      if (res.data.success) {
        const data = res.data.totales;

        this.setState({
          efectivoCalculado: data.efectivo || 0,
          chequeCalculado: data.cheque || 0,
          valesCalculado: data.vales || 0,
          tarjetaCalculado: data.tarjeta || 0,
          transferenciaCalculada: data.transferencia || 0,
          // totalTransferencias: data.transferencia || 0,
          // totalAnticipos: data.anticipos || 0,
          loadingData: false,
        });
      } else {
        message.error("No se pudieron obtener los totales");
        this.setState({ loadingData: false });
      }
    } catch (error) {
      console.error("Error al consultar datos de caja:", error);
      message.error("Error al consultar datos de caja");
      this.setState({ loadingData: false });
    }
  };

  // Funciones para manejar el modal de conteo de efectivo
  abrirModalConteoEfectivo = () => {
    this.setState({ modalConteoEfectivoVisible: true });
  };

  cerrarModalConteoEfectivo = () => {
    this.setState({ modalConteoEfectivoVisible: false });
  };

  handleObservacionesChange = (e) => {
    this.setState({ observaciones: e.target.value });
  };

  confirmarConteoEfectivo = (totalContado) => {
    this.setState({
      efectivo: totalContado,
      modalConteoEfectivoVisible: false
    });
    message.success(`Efectivo actualizado: ${dineroDisabledMask(totalContado)}`);
  };

  calcularDiferencias = () => {
    const { efectivo, cheque, vales, tarjeta, efectivoCalculado, chequeCalculado, valesCalculado, tarjetaCalculado, transferencia, transferenciaCalculada } = this.state;

    return {
      diferenciaEfectivo: efectivo - efectivoCalculado,
      diferenciaCheque: cheque - chequeCalculado,
      diferenciaVales: vales - valesCalculado,
      diferenciaTarjeta: tarjeta - tarjetaCalculado,
      diferenciaTransferencia: transferencia - transferenciaCalculada
    };
  };

  getTotalContado = () => {
    const { efectivo, cheque, vales, tarjeta, transferencia } = this.state;
    return efectivo + cheque + vales + tarjeta + transferencia;
  };

  getTotalCalculado = () => {
    const { efectivoCalculado, chequeCalculado, valesCalculado, tarjetaCalculado, transferenciaCalculada } = this.state;
    return efectivoCalculado + chequeCalculado + valesCalculado + tarjetaCalculado + transferenciaCalculada;
  };

  // Función para determinar si el botón debe estar habilitado
  isButtonEnabled = () => {
    const totalContado = this.getTotalContado();
    const totalCalculado = this.getTotalCalculado();
    const totalDiferencia = totalContado - totalCalculado;

    // El botón está habilitado si la diferencia total es >= 0
    return totalDiferencia >= 0;
  };

  handleGuardar = async () => {
    // Verificar nuevamente antes de guardar
    if (!this.isButtonEnabled()) {
      message.warning('No se puede guardar el corte de caja con diferencias negativas');
      return;
    }

    this.setState({ loading: true });

    try {
      const res = await axios.post(
        "puntoVenta/corteCaja",
        {
          sesionId: this.props.sesionId,
          efectivo: this.state.efectivo,
          cheque: this.state.cheque,
          vales: this.state.vales,
          tarjeta: this.state.tarjeta,
          transferencia: this.state.transferencia,
          observaciones: this.state.observaciones,
        },
        { headers: this.props.headersToken }
      );

      if (res.data.success) {
        message.success('Corte de caja guardado exitosamente');
        this.setState({ pdfVisible: true });
      } else {
        message.error('Error al guardar el corte de caja');
      }

      this.setState({ loading: false });
    } catch (error) {
      console.error("Error al guardar el corte de caja:", error);
      message.error('Error al guardar el corte de caja');
      this.setState({ loading: false });
    }
  };

  cerrarModalPdfCorteDeCaja = () => {
    this.props.corteConfirmado();
  }


  handleCancel = () => {
    if (this.state.loading) {
      return;
    }
    this.props.onCancel();
  };

  render() {
    const { visible, cajaNombre } = this.props;
    const { loading, loadingData } = this.state;
    const diferencias = this.calcularDiferencias();
    const totalContado = this.getTotalContado();
    const totalCalculado = this.getTotalCalculado();
    const totalDiferencia = totalContado - totalCalculado;
    const isButtonEnabled = this.isButtonEnabled();

    const metodosData = [
      {
        key: 'efectivo',
        metodo: 'Efectivo',
        contado: this.state.efectivo,
        calculado: this.state.efectivoCalculado,
        diferencia: diferencias.diferenciaEfectivo,
        icon: <DollarOutlined style={{ color: '#52c41a' }} />,
        mostrarBotonConteo: true
      },
      {
        key: 'cheque',
        metodo: 'Cheque',
        contado: this.state.cheque,
        calculado: this.state.chequeCalculado,
        diferencia: diferencias.diferenciaCheque,
        icon: <FileTextOutlined style={{ color: '#1890ff' }} />
      },
      {
        key: 'vales',
        metodo: 'Vales',
        contado: this.state.vales,
        calculado: this.state.valesCalculado,
        diferencia: diferencias.diferenciaVales,
        icon: <BankOutlined style={{ color: '#faad14' }} />
      },
      {
        key: 'tarjeta',
        metodo: 'Tarjeta',
        contado: this.state.tarjeta,
        calculado: this.state.tarjetaCalculado,
        diferencia: diferencias.diferenciaTarjeta,
        icon: <CreditCardOutlined style={{ color: '#E96827' }} />
      },
      {
        key: 'transferencia',
        metodo: 'Transferencia',
        contado: this.state.transferencia,
        calculado: this.state.transferenciaCalculada,
        diferencia: diferencias.diferenciaTransferencia,
        icon: <BankOutlined style={{ color: '#faad14' }} />
      }
    ];

    return (
      <>
        <Modal
          title={
            <Space>
              <CalculatorOutlined style={{ color: '#00b5e2' }} />
              <span>Corte de Caja</span>
            </Space>
          }
          visible={visible}
          onCancel={this.handleCancel}
          footer={null}
          width={900}
          centered
          closable={!loading}
          maskClosable={!loading}
        >
          <Spin spinning={loading || loadingData} tip={loading ? "Guardando corte de caja..." : "Cargando datos..."}>
            <div style={{ padding: '0 8px' }}>
              {/* Header con nombre de caja */}
              <Card
                style={{
                  marginBottom: '16px',
                  backgroundColor: '#f0f2f5',
                  border: '1px solid #00b5e2'
                }}
              >
                <Row justify="space-between" align="middle">
                  <Col>
                    <Title level={4} style={{ margin: 0, color: '#00b5e2' }}>
                      Caja: {cajaNombre || 'Caja 1'}
                    </Title>
                  </Col>
                  <Col>
                    <Text style={{ color: '#666' }}>
                      Retiro por Corte
                    </Text>
                  </Col>
                </Row>
              </Card>

              {/* Tabla principal */}
              <Card style={{ marginBottom: '16px' }}>
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <div style={{ overflowX: 'auto' }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                          <tr style={{ backgroundColor: '#fafafa' }}>
                            <th style={{ padding: '8px', border: '1px solid #e8e8e8', textAlign: 'left' }}>
                              <Text strong>Método</Text>
                            </th>
                            <th style={{ padding: '8px', border: '1px solid #e8e8e8', textAlign: 'center' }}>
                              <Text strong>Contado</Text>
                            </th>
                            <th style={{ padding: '8px', border: '1px solid #e8e8e8', textAlign: 'center' }}>
                              <Text strong>Calculado</Text>
                            </th>
                            <th style={{ padding: '8px', border: '1px solid #e8e8e8', textAlign: 'center' }}>
                              <Text strong>Diferencia</Text>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {metodosData.map((item) => (
                            <tr key={item.key}>
                              <td style={{ padding: '8px', border: '1px solid #e8e8e8' }}>
                                <Space>
                                  {item.icon}
                                  <Text>{item.metodo}</Text>
                                </Space>
                              </td>
                              <td style={{ padding: '8px', border: '1px solid #e8e8e8', textAlign: 'center' }}>
                                <Space>
                                  <InputNumber
                                    value={item.contado}
                                    onChange={(value) => this.setState({ [item.key]: value || 0 })}
                                    style={{ width: '100px' }}
                                    precision={2}
                                    min={0}
                                    disabled={loading || loadingData}
                                  />
                                  {item.mostrarBotonConteo && (
                                    <Button
                                      type="primary"
                                      size="small"
                                      icon={<CalculatorOutlined />}
                                      onClick={this.abrirModalConteoEfectivo}
                                      disabled={loading || loadingData}
                                      style={{
                                        backgroundColor: '#52c41a',
                                        borderColor: '#52c41a'
                                      }}
                                    >
                                      Contar
                                    </Button>
                                  )}
                                </Space>
                              </td>
                              <td style={{ padding: '8px', border: '1px solid #e8e8e8', textAlign: 'center' }}>
                                <Text>{dineroDisabledMask(item.calculado)}</Text>
                              </td>
                              <td style={{ padding: '8px', border: '1px solid #e8e8e8', textAlign: 'center' }}>
                                <Text
                                  style={{
                                    color: item.diferencia === 0 ? '#52c41a' : item.diferencia > 0 ? '#1890ff' : '#ff4d4f',
                                    fontWeight: 'bold'
                                  }}
                                >
                                  {dineroDisabledMask(item.diferencia)}
                                </Text>
                              </td>
                            </tr>
                          ))}

                          {/* Fila de totales */}
                          <tr style={{ backgroundColor: '#C9D51D', fontWeight: 'bold' }}>
                            <td style={{ padding: '12px', border: '1px solid #e8e8e8' }}>
                              <Text strong>Total</Text>
                            </td>
                            <td style={{ padding: '12px', border: '1px solid #e8e8e8', textAlign: 'center' }}>
                              <Text strong>{dineroDisabledMask(totalContado)}</Text>
                            </td>
                            <td style={{ padding: '12px', border: '1px solid #e8e8e8', textAlign: 'center' }}>
                              <Text strong>{dineroDisabledMask(totalCalculado)}</Text>
                            </td>
                            <td style={{ padding: '12px', border: '1px solid #e8e8e8', textAlign: 'center' }}>
                              <Text
                                strong
                                style={{
                                  color: totalDiferencia === 0 ? '#52c41a' : totalDiferencia > 0 ? '#1890ff' : '#ff4d4f'
                                }}
                              >
                                {dineroDisabledMask(totalDiferencia)}
                              </Text>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </Row>
              </Card>

              {/* Información adicional */}
              {/* <Card
                title="Información Adicional"
                style={{ marginBottom: '16px' }}
                bodyStyle={{ padding: '16px' }}
              >
                <Row gutter={[16, 8]}>
                  <Col span={8}>
                    <Text>Total Transferencias:</Text>
                  </Col>
                  <Col span={4}>
                    <Text strong>{dineroDisabledMask(this.state.totalTransferencias)}</Text>
                  </Col>
                  <Col span={8}>
                    <Text>Total Anticipos:</Text>
                  </Col>
                  <Col span={4}>
                    <Text strong>{dineroDisabledMask(this.state.totalAnticipos)}</Text>
                  </Col>
                </Row>

                <Divider />
                <Text style={{ fontSize: '12px', color: '#666' }}>
                  El total de transferencias también se ven reflejados en los totales del corte de caja
                </Text>
              </Card> */}

              {/* Resumen en el lado derecho */}
              <Card
                title="Retiro por Corte"
                style={{ marginBottom: '16px' }}
                bodyStyle={{ padding: '16px' }}
              >
                <Row gutter={[16, 8]}>
                  <Col span={12}>
                    <Text>Efectivo:</Text>
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                    <Text strong style={{ color: '#52c41a' }}>
                      {dineroDisabledMask(this.state.efectivo)}
                    </Text>
                  </Col>
                </Row>
                <Row gutter={[16, 8]}>
                  <Col span={12}>
                    <Text>Cheque:</Text>
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                    <Text strong style={{ color: '#1890ff' }}>
                      {dineroDisabledMask(this.state.cheque)}
                    </Text>
                  </Col>
                </Row>
                <Row gutter={[16, 8]}>
                  <Col span={12}>
                    <Text>Vales:</Text>
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                    <Text strong style={{ color: '#faad14' }}>
                      {dineroDisabledMask(this.state.vales)}
                    </Text>
                  </Col>
                </Row>
                <Row gutter={[16, 8]}>
                  <Col span={12}>
                    <Text>Tarjeta:</Text>
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                    <Text strong style={{ color: '#E96827' }}>
                      {dineroDisabledMask(this.state.tarjeta)}
                    </Text>
                  </Col>
                </Row>
                <Row gutter={[16, 8]}>
                  <Col span={12}>
                    <Text>Transferencia:</Text>
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                    <Text strong style={{ color: '#E96827' }}>
                      {dineroDisabledMask(this.state.transferencia)}
                    </Text>
                  </Col>
                </Row>
                <Divider />
                <Row gutter={[16, 8]}>
                  <Col span={12}>
                    <Text strong>Total:</Text>
                  </Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                    <Text strong style={{ fontSize: '18px', color: '#E96827' }}>
                      {dineroDisabledMask(totalContado)}
                    </Text>
                  </Col>
                </Row>
              </Card>

              {/* Observaciones */}
              <Card
                title="Observaciones"
                style={{ marginBottom: '16px' }}
                bodyStyle={{ padding: '16px' }}
              >
                <TextAreaItem
                  rows={3}
                  placeholder="Observaciones del corte de caja (opcional)"
                  value={this.state.observaciones}
                  onChange={this.handleObservacionesChange}
                  maxLength={500}
                />
              </Card>

              {/* Mensaje de advertencia cuando el botón esté deshabilitado */}
              {!isButtonEnabled && (
                <Card
                  style={{
                    marginBottom: '16px',
                    backgroundColor: '#fff2e8',
                    border: '1px solid #ffb37d'
                  }}
                >
                  <Text style={{ color: '#d46b08', fontWeight: 'bold' }}>
                    ⚠️ El corte de caja no puede guardarse con diferencias negativas.
                    Ajuste los valores contados para que coincidan o superen los valores calculados.
                  </Text>
                </Card>
              )}

              {/* Botón de guardar */}
              <div style={{ textAlign: 'center' }}>
                <Space>
                  <ButtonItem
                    type="primary"
                    icon={<SaveOutlined />}
                    onClick={this.handleGuardar}
                    loading={loading}
                    disabled={!isButtonEnabled || loading || loadingData}
                    style={{
                      backgroundColor: isButtonEnabled ? '#00b5e2' : undefined,
                      borderColor: isButtonEnabled ? '#00b5e2' : undefined,
                      height: '40px',
                      paddingLeft: '24px',
                      paddingRight: '24px'
                    }}
                  >
                    {loading ? 'Guardando...' : 'Guardar Corte de Caja'}
                  </ButtonItem>
                  <ButtonItem
                    onClick={this.handleCancel}
                    disabled={loading}
                    rojo
                    style={{ height: '40px', paddingLeft: '24px', paddingRight: '24px' }}
                  >
                    Cancelar
                  </ButtonItem>
                </Space>
              </div>
            </div>
          </Spin>
        </Modal>

        {/* Modal de conteo de efectivo */}
        <ModalConteoEfectivo
          visible={this.state.modalConteoEfectivoVisible}
          onCancel={this.cerrarModalConteoEfectivo}
          onConfirmar={this.confirmarConteoEfectivo}
          valorInicial={this.state.efectivo}
          efectivoCalculado={this.state.efectivoCalculado}
        />
        <ModalPdfCorteCaja
          impresoraSeleccionada={this.props.impresoraSeleccionada}
          visible={this.state.pdfVisible}
          cerrarModalPdfCorteDeCaja={this.cerrarModalPdfCorteDeCaja}
          id={this.props.sesionId}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          imprimirTicket
        />
      </>
    );
  }
}

export default ModalCorteCaja;